import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Col, Row } from 'react-bootstrap';

import EntityPropsUpdater from 'component/EntityPropsUpdater';
import FormCodeEditor from '../../forms/FormCodeEditor';
import axios from 'axios';
import Axios from 'axios';
import Button from 'react-bootstrap/lib/Button';
import { addNotification } from 'actions/NotificationsActions';

class ProductTemplateCSS extends EntityPropsUpdater {
  constructor(props) {
    super(props);

    this.state = {
      converting: false,
    };
  }

  // send a request that will convert the css to a pdf x3 compatible css
  convertCss = () => {
    const { entity, doNotify } = this.props;
    this.setState({ converting: true });
    axios
      .get(`/api/producttemplates/${entity.getId()}/convertcsstopdfx3compatible.json`)
      .then(({ data }) => {
        if (data.message.length > 0) {
          let type = data.failed_to_fetch_content_urls.length > 0 ? 'warning' : 'success';
          doNotify(type, data.message);
        }
        this.setState({ converting: false });
        if (data.needed_conversion && data.converted_css.length > 0) {
          this.updateEntity('cssPdfX3Compatible', data.converted_css);
        }
      })
      .catch(error => {
        this.setState({ converting: false });
        doNotify('error', 'Error while converting css to pdf x3 compatible');
        // handle error
        if (Axios.isCancel(error)) {
          console.log('get Request canceled');
        } else {
          console.log(error);
        }
      });
  };

  render() {
    const {
      intl: { messages },
      entity,
      entityLoaded,
      disabled,
      inModal,
    } = this.props;

    let pdfProfileX3Enabled = entityLoaded && typeof entity.getPdfProfileX3 == 'function' && entity.getPdfProfileX3();
    let canConvertCssToPdfX3Compatible =
      entityLoaded && pdfProfileX3Enabled && typeof entity.getId == 'function' && entity.getId()?.length > 0;

    let cssPdfX3Compatible = entityLoaded && canConvertCssToPdfX3Compatible ? entity.getCssPdfX3Compatible() ?? '' : '';

    return (
      <div class="clearfix">
        {entityLoaded ? (
          <div>
            {pdfProfileX3Enabled && (
              <Row>
                <Col xs={12} class="text-right  m-t-20">
                  <Button
                    bsStyle="default m-r-20"
                    onClick={() => this.convertCss()}
                    disabled={disabled || this.state.converting}
                  >
                    <p style={{ margin: '0' }}>
                      {this.state.converting ? <i className="far fa-spin fa-spinner-third" /> : null}
                      <span> {messages.template_css_convert.to_pdf_x3_compatible}</span>
                    </p>
                  </Button>
                </Col>
              </Row>
            )}
            <Row>
              <Col xs={12} md={inModal ? 12 : 6}>
                <div class="panel panel-transparent">
                  <div class="panel-body">
                    <div className="form-group-attached">
                      <Row class="clearfix">
                        <FormCodeEditor
                          label={messages.css}
                          name="css"
                          value={entity.getCss()}
                          meta={entity.getCssMetaInformation()}
                          validation={entity.getCssValidationResult()}
                          onChange={this.updateEntity}
                          disabled={disabled}
                        />
                      </Row>
                    </div>
                  </div>
                </div>
              </Col>
              {canConvertCssToPdfX3Compatible && cssPdfX3Compatible?.trim()?.length > 0 && (
                <Col xs={12} md={inModal ? 12 : 6}>
                  <div className="panel panel-transparent">
                    <div className="panel-body">
                      <div className="form-group-attached">
                        <Row class="clearfix">
                          <FormCodeEditor
                            label={messages.cssPdfX3Compatible}
                            name="css"
                            value={cssPdfX3Compatible}
                            disabled={true}
                          />
                        </Row>
                      </div>
                    </div>
                  </div>
                </Col>
              )}
              <Col xs={12} md={inModal ? 12 : 6}>
                <div class="panel panel-transparent">
                  <div class="panel-body">
                    <div className="form-group-attached">
                      <Row class="clearfix">
                        <FormCodeEditor
                          label={messages.cssPDF}
                          name="cssPDF"
                          value={entity.getCssPDF()}
                          meta={entity.getCssPDFMetaInformation()}
                          validation={entity.getCssPDFValidationResult()}
                          onChange={this.updateEntity}
                          disabled={disabled}
                        />
                      </Row>
                      <Row class="clearfix">
                        <FormCodeEditor
                          label={messages.cssPrintPDF}
                          name="cssPrintPDF"
                          value={entity.getCssPrintPDF()}
                          meta={entity.getCssPrintPDFMetaInformation()}
                          validation={entity.getCssPrintPDFValidationResult()}
                          onChange={this.updateEntity}
                          disabled={disabled}
                        />
                      </Row>
                      {typeof entity.getCssAccessibilityPDF === 'function' ? (
                        <Row class="clearfix">
                          <FormCodeEditor
                            label={messages.css_accessibility_pdf}
                            name="cssAccessibilityPDF"
                            value={entity.getCssAccessibilityPDF()}
                            meta={entity.getCssAccessibilityPDFMetaInformation()}
                            validation={entity.getCssAccessibilityPDFValidationResult()}
                            onChange={this.updateEntity}
                            disabled={disabled}
                            infoText={messages.css_accessibility_pdf_info_text}
                          />
                        </Row>
                      ) : null}
                      <Row class="clearfix">
                        <FormCodeEditor
                          label={messages.cssWebsite}
                          name="cssWebsite"
                          value={entity.getCssWebsite()}
                          meta={entity.getCssWebsiteMetaInformation()}
                          validation={entity.getCssWebsiteValidationResult()}
                          onChange={this.updateEntity}
                          disabled={disabled}
                        />
                      </Row>
                      {typeof entity.getJsWebsite === 'function' ? (
                        <Row class="clearfix">
                          <FormCodeEditor
                            label={messages.jsWebsite}
                            name="jsWebsite"
                            value={entity.getJsWebsite()}
                            meta={entity.getJsWebsiteMetaInformation()}
                            validation={entity.getJsWebsiteValidationResult()}
                            onChange={this.updateEntity}
                            disabled={disabled}
                          />
                        </Row>
                      ) : null}
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        ) : null}
      </div>
    );
  }
}

ProductTemplateCSS.defaultProps = {
  inModal: false,
};

const mapDispatchToProps = dispatch => {
  return {
    doNotify: (code, text) => {
      dispatch(addNotification(code, text));
    },
  };
};

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    meta: state.entityMeta,
  };
};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(ProductTemplateCSS));
